import {
  AUSTRALIA_PHONE,
  CountryCall,
  countryCallByCode,
  CountryCodes,
} from 'data/countries';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';

export type Phone = {
  phoneNumber: string;
  country: CountryCodes;
  countryCode: CountryCall;
};

export const getIsValidPhone = (phone: Partial<Phone>) =>
  isValidPhoneNumber(phone?.phoneNumber || '', phone?.country as CountryCode);

export const getIsPhoneNumber = (value: string) => {
  if (!value) return false;

  // Remove all non-digit characters to count digits
  const digitsOnly = value.replace(/\D/g, '');

  return getIsValidPhone(getPhone(digitsOnly));
};

export const getPhone = (contactNumber: string) => {
  let trimmedNumber = contactNumber.replace(/\s+/g, '');

  if (!trimmedNumber.startsWith('+')) {
    trimmedNumber = '+' + trimmedNumber;
  }

  const countryEntries = Object.entries(countryCallByCode);

  for (const [country, code] of countryEntries) {
    if (trimmedNumber.startsWith(code)) {
      return {
        countryCode: code,
        country,
        phoneNumber: trimmedNumber.substring(code.length),
      };
    }
  }

  return undefined;
};

export const getContactNumber = (phone: Partial<Phone>) => {
  if (!phone?.countryCode || !phone?.phoneNumber) return '';

  return `${phone.countryCode}${phone.phoneNumber}`;
};

export const getInitialPhone = () => ({
  country: AUSTRALIA_PHONE.code,
  countryCode: AUSTRALIA_PHONE.call,
});

export const formatPhoneNumber = (phoneNumber: string | Partial<Phone>) => {
  let contactNumber: string;

  if (typeof phoneNumber !== 'string') {
    contactNumber = getContactNumber(phoneNumber);
  } else {
    contactNumber = phoneNumber;
  }

  if (!contactNumber) return '';

  const number = contactNumber.replaceAll(' ', '');

  const [prefix, suffix] = [number.slice(0, 3), number.slice(3)];

  if (prefix !== AUSTRALIA_PHONE.call) {
    return contactNumber;
  }

  // mobile
  if (suffix[0] === '4') {
    return `0${suffix.replace(/.{3}/g, '$& ')}`;
  }

  // landline
  return `(0${suffix[0]}) ${suffix.slice(1).replace(/.{4}/g, '$& ')}`;
};
